/*
 * Tenue — media-gallery.js
 * Product media carousel.
 */
(function () {
  'use strict';

  const Tenue = window.Tenue;

  /* ------------------------------------------------------------------------
     <media-gallery>
     ------------------------------------------------------------------------ */
  if (!customElements.get('media-gallery')) {
    class MediaGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevButton = this.querySelector('[data-gallery-prev]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.thumbs = this.querySelector('.gallery__thumbs');
        this.dots = Array.from(this.querySelectorAll('.gallery__dot'));

        if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.setActiveMedia(dot.dataset.mediaId)));
        this.track.addEventListener('scroll', Tenue.debounce(() => this.update(), 60), { passive: true });
        this.update();
      }

      get direction() {
        return getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      }

      get index() {
        const width = this.track.clientWidth || 1;
        return Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / width)));
      }

      goTo(index, behavior) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({
          left: target * this.track.clientWidth * this.direction,
          behavior: behavior || 'smooth',
        });
      }

      setActiveMedia(mediaId, behavior) {
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index > -1) this.goTo(index, behavior);
      }

      update() {
        const index = this.index;
        const slide = this.slides[index];
        this.dots.forEach((dot) =>
          dot.setAttribute('aria-current', String(Boolean(slide) && dot.dataset.mediaId === slide.dataset.mediaId))
        );
        if (this.prevButton) this.prevButton.disabled = index <= 0;
        if (this.nextButton) this.nextButton.disabled = index >= this.slides.length - 1;
        if (slide && slide.dataset.ratio) this.style.setProperty('--frame-ratio', slide.dataset.ratio);
        if (slide) this.revealThumb(slide.dataset.mediaId);
        if (this.activeIndex !== undefined && this.activeIndex !== index) {
          const previous = this.slides[this.activeIndex];
          if (previous) {
            previous.querySelectorAll('deferred-media').forEach((media) => {
              if (typeof media.pause === 'function') media.pause();
            });
          }
        }
        this.activeIndex = index;
      }

      /* Centers the active thumbnail when the row scrolls, without moving the page. */
      revealThumb(mediaId) {
        if (!this.thumbs || this.thumbs.scrollWidth <= this.thumbs.clientWidth) return;
        const thumb = this.dots.find((dot) => dot.dataset.mediaId === String(mediaId));
        if (!thumb) return;
        this.thumbs.scrollTo({
          left: thumb.offsetLeft - (this.thumbs.clientWidth - thumb.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }
    }
    customElements.define('media-gallery', MediaGallery);
  }
})();
